module.exports = __webpack_public_path__ + "static/media/abs.4394ae54.png";